module.exports = zebDshAppFrame;